import Stars from 'components/Stars'
import manufacturerUrl from 'helpers/manufacturerUrl'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import useProduct from 'store/SingleProductProvider'
import {
  ProductMetaTop,
  ProductRating,
  ProductTitle,
  ProductType,
} from './MainInfo/MainInfo.style'

export default function ProductMeta(props) {
  const { product } = useProduct()

  return (
    <Fragment>
      <ProductMetaTop>
        {product.manufacturer.name ? (
          <ProductType
            itemProp="brand"
            itemScope
            itemType="https://schema.org/Brand"
          >
            {product.manufacturer ? (
              <meta
                itemProp="url"
                content={manufacturerUrl(product.manufacturer?.slug)}
              />
            ) : null}
            {product.manufacturer ? (
              <Link
                to={manufacturerUrl(product.manufacturer?.slug)}
                className="firm"
                itemProp="name"
              >
                {product.manufacturer.image ? (
                  <img
                    src={product.manufacturer.image}
                    alt={product.manufacturer.name}
                  />
                ) : null}
                {product.manufacturer?.name}
              </Link>
            ) : null}
          </ProductType>
        ) : null}
        <ProductRating>
          <p>
            SKU: <span itemProp="sku">{product.sku}</span>
          </p>
          <div
            className="rating-div"
            itemProp="aggregateRating"
            itemScope
            itemType="https://schema.org/AggregateRating"
          >
            <Stars amount={Math.round(product.rating / 2)} />
            <p>
              <span itemProp="reviewCount">{product.vote}</span> შეფასება
            </p>
          </div>
        </ProductRating>
      </ProductMetaTop>
      <ProductTitle
        style={
          props.Browser
            ? {
                borderBottom: '1px solid #E5E5E5',
                paddingBottom: ' 20px',
                marginBottom: '-20px',
              }
            : {}
        }
        itemProp="name"
      >
        {product.name}
      </ProductTitle>
    </Fragment>
  )
}
